import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import { getMonthlyParkingReports } from "helpers/fakebackend_helper";
import MonthlyOrdersTable from "./MonthlyOrdersTable";
import AddMonthlyParkingPaymentModal from "./AddMonthlyParkingSubscriptionModal";

const MonthlyParking = props => {
  document.title = "Monthly Parking | CurbDash";
  const user = JSON.parse(localStorage.getItem("authUser"));
  const [orders, setOrders] = useState([])
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)

  const loadMonthlyParkingOrders = async () => {
    const { data } = await getMonthlyParkingReports(user.token, { monthlyPage: true });
    setOrders(data);
  }

  useEffect(() => {
    loadMonthlyParkingOrders()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content" style={{ marginTop: -70 }}>
        <Container fluid>
          {/* <Row className="d-flex justify-content-between align-items-center mb-4">
            <Col sm="auto">
              <Button
                className="button-gradient-bg"
                onClick={() => setIsAddModalOpen(!isAddModalOpen)}
              >
                Add Payment
              </Button>
            </Col>
          </Row> */}
          <Row>
            <Col xl={12}>
              <MonthlyOrdersTable orders={orders} reloadTime={loadMonthlyParkingOrders} />
            </Col>
          </Row>
        </Container>
      </div>
      <AddMonthlyParkingPaymentModal
        isOpen={isAddModalOpen}
        toggle={() => setIsAddModalOpen(!isAddModalOpen)}
        handleSave={() => {
          loadMonthlyParkingOrders()
          setIsAddModalOpen(false)
        }}
        orders={orders}
      />
    </React.Fragment>
  );
};

MonthlyParking.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(MonthlyParking);
